import { Switch } from "@headlessui/react";
import { Formik, Form } from "formik";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import {
  updatePermissions,
  updateEditActiveStep,
} from "@/reducers/client_user/roleAccess";
import { allPermissionsData } from "@/utilities/defaultData";

const EditModuleAccess = () => {
  const {
    roleAccessData: { allPermission },
  } = useSelector((state) => state.clientRoles);
  const dispatch = useDispatch();
  const [isAllSelected, setIsAllSelected] = useState(false);

  const filteredPermissions = allPermissionsData.filter(
    (ele) => ele.type === "module",
  );

  useEffect(() => {
    const keysArr = _.map(filteredPermissions, "value");
    setIsAllSelected(keysArr.every((key) => allPermission[key]));
  }, [allPermission, filteredPermissions]);

  const handleToggleAll = () => {
    const updatedPermissions = {};
    filteredPermissions.forEach((ele) => {
      updatedPermissions[ele.value] = !isAllSelected;
    });
    dispatch(updatePermissions(updatedPermissions));
  };

  const togglePermission = (key) => {
    dispatch(updatePermissions({ [key]: !allPermission[key] }));
  };

  return (
    <div className="JobDetails_Wrapper mb-14 grid gap-4">
      <div className="grid gap-4">
        <div className="rounded-lg bg-white p-6">
          <Formik
            initialValues={{}}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
              dispatch(updateEditActiveStep(3));
              setSubmitting(false);
            }}
          >
            {({ submitForm, isSubmitting, isValid }) => (
              <Form>
                <div className="mb-4 flex justify-between">
                  <h4 className="text-[18px] font-medium text-black">
                    Module Access
                  </h4>
                  <button
                    type="button"
                    className="h-[40px] w-[120px] cursor-pointer rounded-lg border border-primary bg-white text-[14px] font-medium text-primary transition-all duration-200 hover:bg-primary hover:text-white"
                    onClick={handleToggleAll}
                  >
                    {isAllSelected ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <div className="grid grid-cols-1 gap-[40px] sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4">
                  {filteredPermissions.map((ele) => (
                    <div
                      key={ele.value}
                      className="flex items-center gap-[12px]"
                    >
                      <Switch
                        checked={!!allPermission[ele.value]}
                        onChange={() => togglePermission(ele.value)}
                        className={`inline-flex h-[1.79rem] w-[3.25rem] items-center rounded-full shadow-sm transition-colors duration-200 ${
                          allPermission[ele.value]
                            ? "bg-primary"
                            : "bg-[#dddddd]"
                        }`}
                      >
                        <span
                          className={`inline-block h-[22px] w-[22px] transform rounded-full bg-white shadow-md transition-transform duration-200 ${
                            allPermission[ele.value]
                              ? "translate-x-[25px]"
                              : "translate-x-1"
                          }`}
                        />
                      </Switch>
                      <p
                        className="cursor-pointer select-none text-[14px] font-medium text-black"
                        onClick={() => togglePermission(ele.value)}
                      >
                        {ele.label}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="mt-10 flex justify-end gap-4">
                  <button
                    type="button"
                    className="h-[40px] w-[120px] rounded-lg border border-primary bg-white text-[14px] font-medium text-primary transition-all duration-200 hover:bg-primary hover:text-white"
                    onClick={() => dispatch(updateEditActiveStep(1))}
                  >
                    Previous
                  </button>
                  <button
                    className="ease relative h-[40px] w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium leading-[38px] text-white transition-all duration-200 hover:bg-none hover:text-primary"
                    onClick={submitForm}
                    disabled={isSubmitting || !isValid}
                  >
                    {isSubmitting ? <ButtonLoader /> : "Next"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default EditModuleAccess;
